import styled from "styled-components";
import { typography } from "src/theme";
import { colors } from "src/theme/colors";
import device from "src/constants/media";

export const BackButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: fit-content;
  cursor: pointer;
  margin: 50px 0px;

  :hover {
    div {
      background-color: ${colors.mainVeryLight};
    }
  }
`;

export const BackButtonImageWrapper = styled.div`
  width: 44px;
  height: 44px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid ${colors.greyVeryLight};
  border-radius: 50%;
`;

export const BackButtonText = styled.p`
  margin: 0 12px;
  display: flex;
  align-items: center;
  font-family: ${typography.fontFamily};
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  color: ${colors.grey};
`;
export const ContentWrapper = styled.div`
  padding: 0 24px;

  @media ${device.tablet} {
    display: grid;
    grid-template-columns: 75% 25%;
    grid-template-rows: auto auto auto auto;
    padding: 0 24px;
  }
  @media ${device.laptopS} {
    width: 1096px;
    margin: 0 auto;
  }
`;

export const ClinicsName = styled.div`
  font-family: ${typography.fontFamily};
  font-size: 24px;
  width: 100%;
  color: ${colors.grey};
  font-weight: 500;
  margin-bottom: 40px;
  @media ${device.laptop} {
    font-size: 36px;
  }
`;
export const TotalRaitingWrapper = styled.div`
  @media ${device.tablet} {
    grid-row: 1/5;
    grid-column: 2/3;
  }
`;
export const TotalRatingStickyBox = styled.div`
  position: sticky;
  top: 25px;
`;
